module.exports = __webpack_public_path__ + "static/media/SOCS.f89102f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/SOCS.jpg
// module id = 1777
// module chunks = 1